module.exports = __webpack_public_path__ + "static/media/our-story-leaf-1.2b3802bd.svg";